export const API_BASE_URL = process.env.REACT_APP_API_URL;

export const ALLOWED_FILE_TYPES = [
    'image/jpeg',
    'image/png',
    'application/pdf'
];

export const ENDPOINTS = {
    bandAffiliation: 'Lkp_Band_Affiliation',
    countries: 'Lkp_Country',
    gender: 'Lkp_Gender',
    gradeLevels: 'Lkp_Grade_Level',
    indGroup: 'Lkp_Indigenous_Group',
    livesWith: 'Lkp_Lives_With',
    meridian: 'Lkp_Meridian',
    suffix: 'Lkp_Person_Name_Suffix',
    personRelation: 'Lkp_Person_Relationship',
    personRole: 'Lkp_Person_Role',
    pronoun: 'Lkp_Pronoun',
    province: 'Lkp_Province',
    quarter: 'Lkp_Quarter',
    range: 'Lkp_Range',
    residentType: 'Lkp_Resident_Type',
    schools: 'Lkp_School',
    section: 'Lkp_Section',
    studentRelation: 'Lkp_Student_Relationship',
    township: 'Lkp_Township',
    immStatus: 'Ref_Immigration_Status',
    tuitionStatus: 'Lkp_Tuition_Status',
    // reserveResidence: 'Lkp_Reserve_Of_Residence',
};

export const FORM_FIELDS = {
    IS_REG_PREK: "isRegPrek",
    IS_PREK_APPROVED: "isPreKApproved",
    IS_CAN_CIT: "isCanCit",
    WORKING_WITH_SWIS: "workingWithSWIS",
    REGISTRANT_TYPE: "registrantType",
    REGISTRANT_NAME: "registrantName",
    LAFOIP_SIGNATURE_EMAIL: "lafoipSignatureEmail",
    SCHOOL_RECEIVING: "schoolReceiving",
    ENTRY_DATE: "entryDate",
    GRADE: "grade",
    IS_HOME_ENGLISH_ONLY: "isHomeEnglishOnly",
    HAS_MED_RESTRICT: "hasMedRestrict",
    IS_BUS_REQUIRED: "isBusRequired",
    IS_HERE_HOCKEY: "isHereHockey",
    IS_EXCHANGE_STUDENT: "isExchangeStudent",
    EXCHANGE_PROGRAM_NAME: "exProgName",
    HOCKEY_TEAM_NAME: "hockeyTeamName",
    HAS_PREVIOUS_SCHOOL: "hasPreviousSchool",
    IS_TRANSFERING_WITHIN: "isTransferingWithin",
    ORIGIN_SCHOOL: "originSchool",
    ORIGIN_SCHOOL_CITY: "originSchoolCity",
    ORIGIN_SCHOOL_PROVINCE: "originSchoolProvince",
    ORIGIN_SCHOOL_COUNTRY: "originSchoolCountry",
    STUDENT_FIRST_NAME: "studentFirstName",
    STUDENT_LAST_NAME: "studentLastName",
    STUDENT_MIDDLE_NAME: "studentMiddleName",
    STUDENT_LEGAL_SUFFIX: "studentLegalSuffix",
    STUDENT_GENDER: "studentGender",
    HAS_PREFERRED_NAME: "hasPreferredName",
    STUDENT_PREF_FIRST_NAME: "studentPrefFirstName",
    STUDENT_PREF_LAST_NAME: "studentPrefLastName",
    STUDENT_PREF_MIDDLE_NAME: "studentPrefMiddleName",
    STUDENT_PREF_SUFFIX: "studentPrefSuffix",
    DATE_OF_BIRTH: "dateOfBirth",
    GENDER: "gender",
    STUDENT_HOME_PHONE: "studentHomePhone",
    STUDENT_CELL_PHONE: "studentCellPhone",
    STUDENT_EMAIL: "studentEmail",
    MAILING_BOX_NO: "mailingBoxNo",
    MAILING_RR_NO: "mailingRrNo",
    MAILING_APT_NO: "mailingAptNo",
    MAILING_HOUSE_NO: "mailingHouseNo",
    MAILING_STREET: "mailingStreet",
    MAILING_CITY: "mailingCity",
    MAILING_PROVINCE: "mailingProvince",
    MAILING_POSTAL_CODE: "mailingPostalCode",
    IS_PHYS_SAME_MAILING: "isPhysSameMailing",
    PHYS_APT_NO: "physAptNo",
    PHYS_HOUSE_NO: "physHouseNo",
    PHYS_STREET: "physStreet",
    PHYS_CITY: "physCity",
    PHYS_PROVINCE: "physProvince",
    IS_ON_ACREAGE_FARM: "isOnAcreageFarm",
    PHYS_QUARTER: "physQuarter",
    PHYS_SECTION: "physSection",
    PHYS_TOWNSHIP: "physTownship",
    PHYS_RANGE: "physRange",
    PHYS_MERIDIAN: "physMeridian",
    HAS_PERM_INTER_ADD: "hasPermInterAdd",
    PERM_INT_APT_NO: "permIntAptNo",
    PERM_INT_HOUSE_NO: "permIntHouseNo",
    PERM_INT_STREET: "permIntStreet",
    PERM_INT_CITY: "permIntCity",
    PERM_INT_PROVINCE: "permIntProvince",
    PERM_INT_COUNTRY: "permIntCountry",
};
